import React from "react";
import { useTable, useSortBy } from "react-table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSortDown,
  faSortUp,
  faUnsorted,
} from "@fortawesome/free-solid-svg-icons";
import { textReadableFormat } from "../../utils/Utils";
import { RoutesEnum } from "../../utils/RoutesUtil";
import { useLocation, useNavigate } from "react-router-dom";
import { ISortOptionsModel, TrackersEnum } from "../../models/TrackerModel";
import EllipsisTooltip from "../../utils/EllipsisTooltip";
import { Tooltip } from "react-tooltip";

interface ListViewTrackerPorps {
  config: any;
  data: any;
  setTrackerData: (extraFields: any) => Promise<void>;
  sortOptions?: ISortOptionsModel | null;
  setSortOptions: React.Dispatch<React.SetStateAction<ISortOptionsModel | null>>;
  extraFields?: any
}

const ListViewTracker = (props: ListViewTrackerPorps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setTrackerData, setSortOptions, extraFields } = props;

  const displayText = (text:string,maxLength:number)=>{
    return text && text?.length > maxLength ? `${text && text?.slice(0, maxLength)}...` : text && text;
    
  }

  const accountTooltip = (text:string,maxLength:number,index:any)=>{
    return(
      <>
        <span data-tooltip-id={text && text?.length > maxLength ? index+text && text :""}>{displayText(text && text,maxLength)}</span>
          <Tooltip id={index+text && text}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{text && text}</span>
        </div>
        </Tooltip>
      </>
    )
  }

  const leadDetailsHandler = (rowData: any) => {
    const client_id = props.data.find(
      (m: any, index: number) => index === rowData.index
    )?.clientId;
    const clientProductsId = props.data.find(
      (m: any, index: number) => index === rowData.index
    )?.clientProductsId;
    const getTrackerTypeList = location?.pathname?.split("/");

    const getTrackerType = getTrackerTypeList?.[2] || TrackersEnum.DEFAULT;
    let url = `/${RoutesEnum.TRACKER_DETAILSPAGE}/${getTrackerType}/${client_id}`;
    if (clientProductsId) {
      url = url + `/${clientProductsId}`;
    }
    navigate(url);
  };

  const getTrackerSortValues = (column: any) => {
    let sortColumn = "";
    let sortDirection = "";
    if (column.isSorted === true) {
      sortColumn = columns.find(
        (each: any) => each.Header == column.Header
      )?.accessor;
    }
    if (column.isSortedDesc != null) {
      sortDirection = column.isSortedDesc ? "ASC" : "DESC";
    }
    // console.log("sortColumn", sortColumn);
    // console.log("sortDirection", sortDirection);
    if (sortColumn && sortDirection && setSortOptions) {
      setSortOptions({
        sortColumn,
        sortDirection
      })
    } else {
      setSortOptions(null)
    }
    setTrackerData({
      sortColumn,
      sortDirection,
      ...(extraFields ? extraFields : {} )
    })
  };
  // const dynamicSort = (column:any, sortDirection:any) => (a:any, b:any) => {
  //   const compareValue = a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0;
  //   return sortDirection === 'desc' ? -compareValue : (sortDirection === 'asc' ? compareValue: 0);
  // };

  // const [sortColumn,setSortColumn] = useState();
  // const [sortCount,setSortCount] = useState(0);
  // const [sortDirection,setsortDirection] = useState('desc');

  const data: any[] = React.useMemo(() => {
    // const sortedData = (sortColumn&&sortDirection.length > 0) ? props.data.slice().sort(dynamicSort(sortColumn,sortDirection)) : props.data;
    const items = props.data.map((lead: any,index:any) => ({
      ...props?.config?.listView?.reduce((acc: any, curr: any) => {
        acc[curr.columnField] = lead[curr.columnField];
        if (curr.columnField === "businessName") {
          acc[curr.columnField] = (
              <span className="pointer-cursor">
                <EllipsisTooltip text={
                        lead[curr.columnField]
                      }
                      maxLine={23} />
                </span>
          );
        }
        if (curr.columnField === "account") {
          acc[curr.columnField] = (
              <span className="pointer-cursor">
                {accountTooltip(lead[curr.columnField],15, index)}
                </span>
          );
        } else if (curr.columnField === "percentageToSale") {
          acc[curr.columnField] = lead[curr.columnField] + "%";
        } else {
          acc[curr.columnField] = lead[curr.columnField];
        }
        return acc;
      }, {} as any),
    }));
    return items;
  }, [props?.data]);

  const columns: any = React.useMemo(
    () =>
      props?.config?.listView?.map((columnData: any) => ({
        Header: textReadableFormat(columnData.columnTitle),
        accessor: columnData.columnField,
      })),
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data, manualSortBy: true }, useSortBy);

  return (
    <>
      <div className="listViewWrap">
        <table {...getTableProps()} className="listViewTable">
          <thead>
            {headerGroups?.map((headerGroup: any, index: number) => (
              <tr {...headerGroup?.getHeaderGroupProps()} key={index}>
                {headerGroup?.headers?.map(
                  (column: any, columnIndex: number) => (
                    <th
                      key={columnIndex}
                      {...column?.getHeaderProps(
                        column?.getSortByToggleProps()
                      )}
                      style={{
                        background: "aliceblue",
                        color: "black",
                        fontWeight: "bold",
                      }}
                      className={column?.id}
                    >
                      <div
                        className="sortnigColumnDiv"
                        onClick={() =>
                          setTimeout(() => {
                            getTrackerSortValues(column);
                          }, 10)
                        }
                      >
                        <span className="pointer-cursor">
                          {column?.render("Header")}{" "}
                        </span>
                        <span>
                          <FontAwesomeIcon icon={faUnsorted} />
                          {column?.isSorted ? (
                            column?.isSortedDesc ? (
                              <FontAwesomeIcon icon={faSortUp} />
                            ) : (
                              <FontAwesomeIcon icon={faSortDown} />
                            )
                          ) : (
                            ""
                          )}
                        </span>
                        {/* <span>
                  <FontAwesomeIcon icon={faUnsorted} />
      {sortColumn === column.id && sortDirection === 'desc' ? <FontAwesomeIcon icon={faSortUp} />: <FontAwesomeIcon icon={faSortDown} />}
      {sortColumn === column.id && sortDirection === 'asc' ? <FontAwesomeIcon icon={faSortDown} />: <FontAwesomeIcon icon={faSortUp} />}
                  </span> */}
                      </div>
                    </th>
                  )
                )}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows?.map((row: any, rowIndex: number) => {
              prepareRow(row);
              return (
                <tr
                  key={rowIndex}
                  {...row.getRowProps()}
                  className="listRow"
                  onClick={() => leadDetailsHandler(row)}
                >
                  {row?.cells?.map((cell: any, rowCellsIndex: number) => {
                    return (
                      <td
                        key={rowCellsIndex}
                        {...cell?.getCellProps()}
                        style={{
                          padding: "10px",
                          border: "solid 1px gray",
                        }}
                        className={cell?.column?.id}
                      >
                        {cell?.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListViewTracker;
